module.exports = __webpack_public_path__ + "static/img/戴防护镜.fae261f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/warnSign/戴防护镜.png
// module id = 7J1z
// module chunks = 1